// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { useLocalMessage } from '@Helpers/';
import { FormInstance } from 'antd/lib/form';
import { ObservableTypeOutput } from 'thehive-sdk';
import { THForm } from '@Molecules/THForm/THForm';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THSwitch } from '@Molecules/Inputs/THSwitch/THSwitch';
import { FormSubmitButton } from '@Atoms/Buttons/FormSubmitButton/FormSubmitButton';

export interface ObservableTypeValuesForm {
    name: string;
    isAttachment: boolean;
}

interface ObservableTypeFormProps {
    form: FormInstance;
    defaultValues?: ObservableTypeOutput;
    isValid: boolean;
    onFinish(values: ObservableTypeValuesForm): void;
    onChange: () => void;
    onCancel: () => void;
}

export const ObservableTypeForm = ({
    form,
    defaultValues,
    isValid,
    onFinish,
    onChange,
    onCancel,
}: ObservableTypeFormProps): ReactElement => {
    const i = useLocalMessage();

    const tradLabelKey = !!defaultValues ? 'edit' : 'create';

    return (
        <THForm<ObservableTypeValuesForm>
            name="observable-type-form"
            onFinish={onFinish}
            form={form}
            initialValues={defaultValues}
            onValuesChange={onChange}
        >
            <THForm.Layout
                footer={
                    <FormSubmitButton
                        onCancel={onCancel}
                        disabled={!isValid}
                        footerText={i(`observable-type.${tradLabelKey}.form.submit`)}
                    />
                }
            >
                <THForm.Item
                    label={i('observable-type.create.form.name.label')}
                    name="name"
                    rules={[{ required: true, message: i('observable-type.create.form.name.required') }]}
                >
                    <THInput
                        placeholder={i('observable-type.create.form.name.placeholder')}
                        disabled={!!defaultValues}
                    />
                </THForm.Item>

                <THForm.Item
                    name="isAttachment"
                    label={i('observable-type.create.form.is-attachment.label')}
                    valuePropName="checked"
                    horizontal
                >
                    <THSwitch />
                </THForm.Item>
            </THForm.Layout>
        </THForm>
    );
};
